
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcStockApproveHdDialog extends Serenity.EntityDialog<IcStockApproveHdRow, any> {
        protected getFormKey() { return IcStockApproveHdForm.formKey; }
        protected getIdProperty() { return IcStockApproveHdRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockApproveHdRow.localTextPrefix; }
        protected getNameProperty() { return IcStockApproveHdRow.nameProperty; }
        protected getService() { return IcStockApproveHdService.baseUrl; }
        protected getDeletePermission() { return IcStockApproveHdRow.deletePermission; }
        protected getInsertPermission() { return IcStockApproveHdRow.insertPermission; }
        protected getUpdatePermission() { return IcStockApproveHdRow.updatePermission; }

        protected form = new IcStockApproveHdForm(this.idPrefix);

        constructor() {
            super();

            this.form = new IcStockApproveHdForm(this.idPrefix);
            this.form.PostFg.element.parent();


            (this.form.IcStockCountTranList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
            });

        }

        protected initToolbar() {
            super.initToolbar();

        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

           
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSavePosBtn: Serenity.ToolButton =
                {
                    title: "อนุมัติ",
                    hint: "Apporve and post [alt+shift+s]",
                    separator: false,
                    cssClass: "button-approve",
                    icon: "fa fa-save",
                    hotkey: 'alt+shift+s',
                    onClick: (e) => {
                        //--เซฟครั้งที่ 1 ต้องเตะสร้าง
                        //---สร้างtemp สรุปรายการใบปรับปรุงเพิ่ม/ลดที่เกิดขึ้นก่อน


                        Q.confirm('ยืนยันการบันทึกเอกสาร POST'+  "\r\n" + 
                        'เมื่ออนุมัติ ระบบจะทำการ สร้างเอกสาร ปรับปรุงเพิ่มและลดโดยอัตโนมัติ และสั่ง POST', () => {
                            this.form.ApproveFg.value = "1";
                            this.form.PostFg.value = "3";
                            this.form.ApproveFg.forceUpdate();
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });

                    }
                };
                buttons.push(newSavePosBtn);
                let newBtn: Serenity.ToolButton =
                {
                    title: "Reject",
                    hint: "Reject",
                    separator: false,
                    cssClass: "button-reject",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {
    
                        Q.confirm('ตีกลับเอกสารนี้'
                            , () => {
                                this.form.ApproveFg.value = "0";
                            this.save((response) => {   
            
                                this.dialogClose();
    
    
                            })
                        });
                           
                        
                        
                    }
                };
                buttons.push(newBtn);
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            return buttons;
        }
        protected beforeLoadEntity() {
            let self = this;
            self.toolbar.findButton('save-and-close-button').text('บันทึกเอกสาร');
            self.toolbar.findButton('delete-button').text('ลบเอกสาร');

            //this.form.ReceiveDtList.myPassValue = this.entity.SysDocNo
            //if (this.isNew()) {
            //    this.getNextNumber();
            //}

        }
        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.IcStockCountTranList.myPassValue = this.entity.SysDocNo;

            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();

            if (this.entity.PostFg == 1 || this.entity.PostFg == 2 || this.entity.CancelFg == 1) {
                this.toolbar.findButton('creates-followup-button').hide();
                this.toolbar.findButton('genarate-po-button').hide();
                this.toolbar.findButton('button-approve').hide();
                this.form.IcStockCountTranList.set_readOnly(true);
                this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);

            } else {
                this.toolbar.findButton('apply-changes-button').hide();

            }

        }

    }
}